import { Component, Input, OnInit } from '@angular/core';
import { Rights } from 'src/app/models/rights';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IdentityRightsService } from 'src/app/services/identityRights.service';
import { IdentityUserService } from 'src/app/services/identityUser.service';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'app-user-roles-permissions',
  templateUrl: './user-roles-permissions.component.html'
})
export class UserRolesPermissionsComponent implements OnInit {

  @Input() userGuid!: string;

  organisationGuid!: string;
  roles: any[] = [];
  user!: User;
  adminRightsCurrentUser: string[] = [];
  righsEditable: boolean = false;

  constructor(private authenticationService: AuthenticationService, private userService: IdentityUserService, private rightsService: IdentityRightsService,
    private loggingService: LoggingService) {
  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data.isOrganisationAdmin) this.adminRightsCurrentUser.push('OrganisationAdmin');
      if (data.isWhitelabelAdmin) this.adminRightsCurrentUser.push('EnterpriseAdmin');
      if (data.isSystemAdmin) this.adminRightsCurrentUser.push('WhitelabelAdmin');
      this.organisationGuid = data.organisationGuid;
      this.user = data;
      this.righsEditable = this.userGuid !== data.sub;

      this.getUserRights(this.userGuid);
    });
  }

  getUserRights(forUser: string) {
    (this.rightsService.getRights(forUser)).subscribe({
      error: (error) => {
        this.loggingService.logException(error);
      },
      next: (data: any) => {
        this.roles = data;
      }
    });
  }

  async updateRoles(event: any) {
    let rights: Rights = {
      NoAdminRights: !(this.roles.some((s: string) => s === "OrganisationAdmin") || this.roles.some((s: string) => s === "EnterpriseAdmin") || this.roles.some((s: string) => s === "WhitelabelAdmin")),
      OrganisationAdmin: this.roles.some((s: string) => s === "OrganisationAdmin"),
      WhitelabelAdmin: this.roles.some((s: string) => s === "EnterpriseAdmin"),
      SystemAdmin: this.roles.some((s: string) => s === "WhitelabelAdmin"),
    };

    (await this.rightsService.updateRights(this.userGuid, rights)).subscribe({
      error: () => {
        // error
      },
      next: (value: any) => {
        // success
      }
    });
  }
}
